var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _class, _class2, _descriptor, _descriptor2, _descriptor3;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { CustomElement, Prop, Event, Watch, Component, html } from '@sick-davinci/ce-decorators';
import { style } from './ToggleGroup.style';
export
/**
 * A `davinci-toggle-group` groups multiple toggleable/selectable elements like checkbox, radio-button or button and emits the selected value on change.
 *
 * Supports all elements with a `value` and a `selected` or `checked` property.
 * @example
 * ```html
 * <davinci-toggle-group>
 *  <davinci-radio-button value="value1">value 1</davinci-radio-button>
 *  <davinci-radio-button value="value2">value 2</davinci-radio-button>
 *  <davinci-radio-button value="value3">value 3</davinci-radio-button>
 * </davinci-toggle-group>
 * ```
 * @slot {*} toggleable elements
 */
let ToggleGroup = (_dec = Component({
  tag: 'davinci-toggle-group',
  style
}), _dec2 = Prop({
  reflectAsAttribute: false
}), _dec3 = Reflect.metadata("design:type", String), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", Boolean), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", String), _dec8 = Event('change'), _dec9 = Reflect.metadata("design:type", Object), _dec10 = Watch('disabled'), _dec11 = Reflect.metadata("design:paramtypes", [Boolean, Boolean]), _dec(_class = (_class2 = class ToggleGroup extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "disabled", _descriptor, this);

    _initializerDefineProperty(this, "name", _descriptor2, this);

    _initializerDefineProperty(this, "changeEvent", _descriptor3, this);

    this._slotChanged = _event => {
      this._updateCheckedState();
    };

    this._changeTrap = event => {
      event.preventDefault();
      event.stopPropagation();
      const element = event.target;

      if (this._internalValue !== element.value) {
        this._internalValue = element.value;

        this._updateCheckedState();

        this.changeEvent.emit(this._internalValue);
      }
    };
  }

  /**
   * Current value of the group.
   */
  set value(val) {
    if (!val) {
      val = '';
    }

    this._internalValue = val;

    this._updateCheckedState();
  }

  get value() {
    return this._internalValue;
  }
  /**
   * Specifies that the whole group should be disabled.
   */


  componentFirstRender() {
    // Safari (does not call @slotchange from above) fix -- https://github.com/whatwg/dom/issues/447
    this._slotChanged(null);
  }

  render() {
    return html`<slot @slotchange="${this._slotChanged}"></slot>`;
  }

  watchDisabled(_oldValue, _newValue) {
    const formElements = this._findFormElement(this);

    formElements.forEach(value => {
      if ('disabled' in value) {
        value.disabled = _newValue;
      }
    });
  }

  _updateCheckedState() {
    const formElements = this._findFormElement(this);

    formElements.forEach(value => {
      // tslint:disable-next-line
      if (value.value == this._internalValue) {
        // == is on purpose
        if ('checked' in value) {
          // tslint:disable-line:no-unsafe-any
          value.checked = true;
        } else {
          value.selected = true;
        }
      } else {
        if ('checked' in value) {
          // tslint:disable-line:no-unsafe-any
          value.checked = false;
        } else {
          value.selected = false;
        }
      }

      if ('disabled' in value) {
        value.disabled = this.disabled;
      }

      value.removeEventListener('change', this._changeTrap);
      value.addEventListener('change', this._changeTrap);
    });
  }

  _findFormElement(base) {
    const array = [];

    if ('value' in base && ( // tslint:disable-line:no-unsafe-any
    'checked' in base || // tslint:disable-line:no-unsafe-any
    'selected' in base)) {
      // tslint:disable-line:no-unsafe-any
      array.push(base);
    } else {
      if (base.children.length >= 0) {
        for (const child of Array.from(base.children)) {
          array.push(...this._findFormElement(child));
        }
      }
    }

    return array;
  }

}, (_applyDecoratedDescriptor(_class2.prototype, "value", [_dec2, _dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "value"), _class2.prototype), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "disabled", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "name", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "changeEvent", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "watchDisabled", [_dec10, _dec11], Object.getOwnPropertyDescriptor(_class2.prototype, "watchDisabled"), _class2.prototype)), _class2)) || _class);
